import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const AnonymousPaymentSession = ApplicationRecord.extend({
  attrs: {
    amount: attr({ type: Number }),
    currency: attr({ type: String }),
    first_name: attr({ type: String }),
    last_name: attr({ type: String }),
    email: attr({ type: String }),
    country_code: attr({ type: String }),
    phone_number: attr({ type: String }),
    address_line1: attr({ type: String }),
    address_line2: attr({ type: String }),
    city: attr({ type: String }),
    state: attr({ type: String }),
    zip: attr({ type: String }),
    country: attr({ type: String }),
    http_origin: attr({ type: String }),
    token: attr({ type: String }),
    url: attr({ type: String }),
  },
  static: {
    endpoint: '/anonymous_payment_sessions',
    jsonapiType: 'external_payments-anonymous_payment_sessions',
  },
});
export default AnonymousPaymentSession;
